import React, { useRef } from 'react';
import { motion, useInView, UseInViewOptions } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  duration?: number;
  once?: boolean;
  amount?: UseInViewOptions['amount'];
}
export function FadeIn({
  children,
  className = '',
  delay = 0,
  direction = 'up',
  duration = 0.6,
  once = true,
  amount = 0.3
}: FadeInProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once,
    amount
  });
  const getInitialVariants = () => {
    switch (direction) {
      case 'up':
        return {
          opacity: 0,
          y: 30
        };
      case 'down':
        return {
          opacity: 0,
          y: -30
        };
      case 'left':
        return {
          opacity: 0,
          x: 30
        };
      case 'right':
        return {
          opacity: 0,
          x: -30
        };
      default:
        return {
          opacity: 0
        };
    }
  };
  const getTargetVariants = () => {
    switch (direction) {
      case 'up':
        return {
          opacity: 1,
          y: 0
        };
      case 'down':
        return {
          opacity: 1,
          y: 0
        };
      case 'left':
        return {
          opacity: 1,
          x: 0
        };
      case 'right':
        return {
          opacity: 1,
          x: 0
        };
      default:
        return {
          opacity: 1
        };
    }
  };
  return <motion.div ref={ref} initial={getInitialVariants()} animate={isInView ? getTargetVariants() : getInitialVariants()} transition={{
    duration,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-11">
      {children}
    </motion.div>;
}